<template>
  <div v-show="show">
    <!--
      todo: we want to use `field.descriptionHtml` as the `label`, but this breaks the error message
      todo: we may want to play with the 'error message' option in Formie
    -->
    <FormKit
      :checked="field.defaultState ? 'checked' : null"
      :help-position="helpPosition"
      :help="field.instructions"
      :label-is-html="true"
      :label="field.name"
      :name="name"
      :placeholder="field.placeholder"
      :validation="validation"
      :value="field.defaultState ? 'checked' : null"
      type="checkbox"
    />
  </div>
</template>

<script setup lang="ts">
import { fieldHelpPosition, fieldName, fieldValidationArray, fieldVisible } from '~/assets/formie'

interface Props {
  settings: object
  parentField?: object
  field: object
}

const props = defineProps<Props>()

const helpPosition = fieldHelpPosition(props.settings, props.field)
const name = fieldName(props.field, props.parentField)
const show = fieldVisible(props.field)
const validation = fieldValidationArray(props.field)
</script>
